// Single source of truth for asset URLs on the frontend (TCX-718).
//
// The storage bucket/host is configuration, not a literal. Hardcoding the
// bucket across components is what let the default-avatar URL drift during the
// bn-dev -> tcx-prod-assets migration. Build asset URLs through these helpers
// so a bucket move stays a config change. Mirrors the backend assetUrl helper.
import { config } from '../config';

const stripTrailingSlash = (s: string): string => s.replace(/\/+$/, '');
const stripLeadingSlash = (s: string): string => s.replace(/^\/+/, '');

// `<endpoint>/<bucket>/app/fch-dev` — same base the backend composes from
// AWS_ENDPOINT + AWS_BUCKET_NAME.
const ASSET_BASE_URL = stripTrailingSlash(config.VITE_ASSET_BASE_URL);

// CDN Space holding shared marketing media (the home-page tutorial videos).
const MEDIA_CDN_URL = stripTrailingSlash(config.VITE_MEDIA_CDN_URL);

// Full URL for a stored object key under the asset base.
export const assetUrl = (key: string): string =>
  `${ASSET_BASE_URL}/${stripLeadingSlash(key)}`;

// Full URL for a path on the marketing media CDN.
export const mediaCdnUrl = (path: string): string =>
  `${MEDIA_CDN_URL}/${stripLeadingSlash(path)}`;

// Shared fallback avatar shown when a user has no profile photo.
export const DEFAULT_AVATAR = assetUrl(
  'da8601c1-7f54-4897-83ef-99ab22adb509-cropped-image.jpg',
);
